import React from 'react';

import { DismissIconSettings } from 'craft/components/DismissIconSettings';
import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { CssSelectorId } from 'craft/types';

export const TourDismiss = ({ nodeIds }: { nodeIds: string[] }) => {
  const {
    props: { hasDismiss },
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const isDismissible = hasDismiss?.value;

  return (
    <Section
      name="Dismissible Tour"
      isExpanded={isDismissible}
      onToggle={() => setProps({ hasDismiss: !isDismissible })}
    >
      <DismissIconSettings
        nodeIds={nodeIds}
        dismissCssSelector={CssSelectorId.TourDismiss}
        dismissSVGCssSelector={CssSelectorId.TourDismissSVG}
      />
    </Section>
  );
};
